import { styled } from '@linaria/react';
import { fonts, primitives, radius, semantic, space } from '../../theme/tokens';

export const Card = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${space['space-400']};
  padding: ${space['space-600']} ${space['space-500']};
  border-radius: ${radius('card', 'radius-xl')};
  background: ${semantic.bg.surfaceSubtle};
`;

export const Copy = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${space['space-100']};
  min-width: 0;
`;

export const Message = styled.span`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  font-weight: ${fonts.weight.normal};
  line-height: ${primitives.typography.lineHeight.normal};
  letter-spacing: ${primitives.typography.tracking.normal};
  color: ${semantic.text.primary};
`;

export const Action = styled.div`
  flex-shrink: 0;
`;
